import { Outlet } from "react-router-dom";
import Header from "../../layouts/header/Header";
import Footer from "../../layouts/footer/Footer";
import ScrollToTop from "../shared/scroll-to-top/ScrollToTopOnPageChange";

const MainRoot = () => {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default MainRoot;
